'use client';

/**
 * Fires a view_item_list event for Google Analytics. *Note: Do not ever push PII into the data layer!!*
 *
 * @example
 * const { fireEvent } = useViewItemListEvent();
 * fireEvent(items);
 */

import { useCallback } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';
import { VIEW_ITEM_LIST_EVENT } from 'constants/analyticsConstants';
import { CartResponse } from 'services/cart/types';
import { getViewItems } from 'utils/gaEventAnalytics';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/_components/analytics-listener/types';

export type ListData = {
  item_list_id: string;
  item_list_name: string;
  currency?: string;
};

export type ViewItemListType = {
  cartId?: string;
  cartItemsData?: CartResponse;
  products: Product[] & ProductsPriceData[];
  locationId?: string;
  type?: string;
  isProductsData?: boolean;
  itemListData?: ListData;
  productStatus?: string;
  page?: number;
  pageSize?: number;
  isDiagramTab?: boolean;
};

export const useViewItemListEvent = () => {
  const buildEvent = useCallback(
    ({
      cartId,
      cartItemsData,
      products,
      locationId,
      isProductsData = false,
      itemListData,
      productStatus,
      page,
      pageSize,
      isDiagramTab = false
    }: ViewItemListType) => {
      return getViewItems({
        cartId,
        cartItemsData,
        products,
        locationId,
        type: VIEW_ITEM_LIST_EVENT,
        isProductsData,
        itemListData,
        productStatus,
        page,
        pageSize,
        isDiagramTab
      });
    },
    []
  );

  const fireEvent = useCallback(
    (data: ViewItemListType) => {
      sendGTMEvent({ ecommerce: null });
      sendGTMEvent(buildEvent(data));
    },
    [buildEvent]
  );

  return { fireEvent };
};
